import type * as React from 'react';

import { Link, type LinkProps } from '@gitbook/spine-react';

import { createDocumentationURL, type DocumentationResource } from '../../utils';

/**
 * Render a link to a page from the GitBook documentation.
 */
export function DocumentationLink(
    props: {
        path: string;
        host?: DocumentationResource;
    } & Omit<LinkProps, 'url'>
): React.ReactElement {
    const { path, children, host, ...rest } = props;
    const url = createDocumentationURL(path, host);
    return (
        <Link {...rest} href={url} target="_blank">
            {children}
        </Link>
    );
}
